module.exports = __webpack_public_path__ + "img/HC2011-127.039025bf.jpg";